<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-enter-otp"
      data-bs-toggle="modal"
      data-bs-target="#modalEnterOtp"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-enter-otp"
      data-bs-dismiss="modal"
      data-bs-target="#modalEnterOtp"
    ></button>
    <div
      class="modal fade"
      id="modalEnterOtp"
      tabindex="-1"
      aria-labelledby="modalEnterOtpLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <KskModalShell :width="680" :show-close="false">
        <div class="ksk-otp">
          <div class="ksk-otp__head">
            <div class="ksk-otp__heading">
              <h2 id="modalEnterOtpLabel" class="ksk-otp__title">{{ $t("kiosk.otp.title") }}</h2>
              <div class="ksk-otp__amount">${{ totalText }}</div>
            </div>
            <!-- `btn-close-modal` stays: verifyOtp() closes the popup with a
                 page-wide $(".btn-close-modal").click(). -->
            <button
              type="button"
              class="btn-close-modal ksk-otp__close"
              :aria-label="$t('kiosk.common.close')"
              data-bs-dismiss="modal"
            >
              <span class="material-icons-round">close</span>
            </button>
          </div>

          <div class="ksk-otp__hint">
            <img class="ksk-otp__wa" src="@/assets/whatsapp.png" alt="" />
            <span>
              {{ $t("kiosk.otp.enterCode") }}
              <strong>WhatsApp{{ maskedPhone ? " " + maskedPhone : "" }}</strong>
            </span>
          </div>

          <div class="ksk-otp__display" @click="focusInput">
            <!-- Hidden input for actual data -->
            <input
              ref="hiddenInput"
              type="tel"
              class="ksk-otp__hidden"
              v-model="input"
              @keydown="onKeyDown"
              @input="handleOtpInput($event)"
              inputmode="numeric"
              maxlength="4"
            />
            <div
              v-for="i in 4"
              :key="i"
              class="ksk-otp__box"
              :class="{
                'ksk-otp__box--active': input.length + 1 === i,
                'ksk-otp__box--filled': !!input[i - 1],
                'ksk-otp__box--error': !!errorMessage && isCodeError,
              }"
            >{{ input[i - 1] || "" }}</div>
          </div>

          <!-- Reserved error line: always takes its height so the layout never jumps. -->
          <div class="ksk-otp__error" role="alert">
            <template v-if="errorMessage">
              <span class="material-icons-round">error_outline</span>
              <span>{{ errorMessage }}</span>
            </template>
          </div>

          <div class="ksk-otp__body">
            <KskNumericKeypad
              class="ksk-otp__keypad"
              clear-token="Clear"
              back-token="X"
              @press="handleKeyClick"
            />
            <div class="ksk-otp__side">
              <div class="ksk-otp__qr-card">
                <div class="ksk-otp__qr-title">{{ $t("kiosk.otp.cantFind") }}</div>
                <div class="ksk-otp__qr-caption">{{ $t("kiosk.otp.scanPortal") }}</div>
                <img v-if="memberSignInQR" class="ksk-otp__qr" :src="memberSignInQR" :alt="$t('kiosk.otp.portalQrAlt')" />
                <div v-else class="ksk-otp__qr ksk-otp__qr--empty">
                  <span class="material-icons-round">qr_code_2</span>
                </div>
              </div>
              <button
                type="button"
                class="ksk-otp__resend"
                :disabled="!activeResendOtp"
                @click="activeResendOtp && resendOtp()"
              >
                <span class="material-icons-round">refresh</span>
                <span>{{ resendLabel }}</span>
              </button>
            </div>
          </div>
        </div>
      </KskModalShell>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading style="z-index: 999999 !important" :active="loaderActive" />
  </div>
</template>

<script>
import $ from "jquery";
import MemberService from "@/services/member.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import { localStorageName } from "@/config/utils";
import kioskService from "../../../services/kiosk.service";
import MaterialLoading from "@/components/MaterialLoading.vue";
import KskModalShell from "./ui/KskModalShell.vue";
import KskNumericKeypad from "./ui/KskNumericKeypad.vue";

export default {
  name: "ModalEnterOtp",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    KskModalShell,
    KskNumericKeypad,
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    memberSignInQR: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      snackbar: null,
      merchantCode: "",
      branchCode: "",
      showFormLogin: false,
      keys: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "Clear", "0", "X"],
      input: "",
      memberType: 1,
      loginType: 1,
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      memberInfo: JSON.parse(
        localStorage.getItem(localStorageName("KIOSK_MEMBER_INFO"), "")
      ),
      step: 0,
      form2: {
        otp: "",
        phone_number: "",
        i_agree: true,
        passcode: "",
        confirmPasscode: "",
        is_empty_passcode: false,
        phone_code: ""
      },
      countryData: [],
      intervalCountdown: null,
      intervalOrderStatus: null,
      seconds: 40,
      activeResendOtp: false,
      showCountdown: true,
      errorMessage: "",
      // The error is about the code typed (red boxes), not e.g. a failed resend.
      isCodeError: false,
      loaderActive: false,
    };
  },
  computed: {
    displayChars() {
      return this.input.split('');
    },
    // KSK029 display-only helpers.
    totalText() {
      const n = Number(this.total);
      return Number.isFinite(n) ? n.toFixed(2) : this.total;
    },
    maskedPhone() {
      const digits = String(this.memberInfo?.phone_number || "").replace(/\D/g, "");
      return digits.length >= 4 ? "••••" + digits.slice(-4) : "";
    },
    resendLabel() {
      if (this.activeResendOtp || !this.showCountdown) return this.$t("kiosk.otp.resend");
      const m = Math.floor(this.seconds / 60);
      const s = this.seconds % 60;
      return this.$t("kiosk.otp.resendIn", { time: `${m}:${s < 10 ? "0" : ""}${s}` });
    },
  },
  mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    MemberService.getCountryDropdown().then(
      (response) => {
        if (response.data.result.isSuccess) {
          this.countryData = response.data.data;
          if (!this.form2.phone_code && this.countryData.length > 0) {
            this.form2.phone_code = this.countryData[0].value;
          }
        }
      }
    );
    // Focus input when modal is opened
    this.$nextTick(() => {
      this.focusInput();
    });
    if (window.$ && window.$('#modalSignIn').on) {
      window.$('#modalSignIn').on('shown.bs.modal', () => {
        this.$nextTick(() => {
          this.focusInput();
        });
      });
    }
    // Listen for number keys from the physical keyboard to automatically focus input
    window.addEventListener('keydown', this.handleGlobalKeydown);

    const modalEl = document.getElementById("modalEnterOtp");
    if (modalEl) {
      modalEl.addEventListener("shown.bs.modal", () => {
        this.resetModalState();
      });
    }
  },
  unmounted() {
    clearInterval(this.intervalOrderStatus);
    this.intervalOrderStatus = null;
    clearInterval(this.intervalCountdown);
    this.intervalCountdown = null;
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleGlobalKeydown);
  },
  methods: {
    resetModalState() {
      this.errorMessage = "";
      this.isCodeError = false;
      this.input = "";
      this.seconds = 40;
      this.activeResendOtp = false;
      this.showCountdown = true;

      clearInterval(this.intervalCountdown);
      this.intervalCountdown = null;
      this.startCountdown();

      this.$nextTick(() => {
        this.focusInput();
      });
    },
    handleOtpInput(e) {
      let value = (e && e.target ? e.target.value : this.input) || "";
      value = value.replace(/\D/g, "").slice(0, 4);

      this.input = value;

      if (this.input.length === 4) {
        this.verifyOtp();
      }
    },
    verifyOtp() {
      this.showLoader();
      var data = {
        phone_number: this.memberInfo?.phone_number,
        otp: this.input
      }

      kioskService.verifyOtp(data, this.merchantCode).then((response) => {
        if (response.data.result.isSuccess) {
          this.snackbar = "success";
          this.message = "One-time PIN verified successfully";
          this.setTimeOutNotification();
          $(".btn-close-modal").click();
          this.$emit("verify-otp-success");
        } else {
          this.input = "";
          this.errorMessage = response.data.result.message || this.$t("kiosk.otp.incorrect");
          this.isCodeError = true;
        }
      })
      .finally(() => {
        this.hideLoader();
      });
    },
    handleKeyClick(key) {

      if (key === "Clear") {
        this.input = "";
      } else if (key === "X") {
        this.input = String(this.input || "").slice(0, -1);
      } else {
        if (/^\d$/.test(key) && this.input.length < 4) {
          this.input = (this.input || "") + key;
        }
      }

      this.input = (this.input || "").replace(/\D/g, "").slice(0, 4);

      this.$nextTick(() => {
        if (this.input.length === 4) {
          this.verifyOtp();
        } else {
          this.focusInput();
        }
      });
    },

    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    onKeyDown(e) {
      if (!((e.key >= '0' && e.key <= '9') || ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Enter'].includes(e.key))) {
        e.preventDefault();
      }
    },
    focusInput() {
      const input = this.$refs.hiddenInput;
      if (input) {
        input.focus();
        input.setSelectionRange(this.input.length, this.input.length);
      }
    },
    handleGlobalKeydown(e) {
      // If it's a number key and input is not focused, focus
      if ((e.key >= '0' && e.key <= '9') && document.activeElement !== this.$refs.hiddenInput) {
        this.focusInput();
      }
      // If Enter is pressed and modal is open, submit
      if (e.key === 'Enter' && document.activeElement === this.$refs.hiddenInput) {
        e.preventDefault();
        this.skip();
      }
    },

    async resendOtp() {
      var dataForm = {
        phone_number: this.memberInfo?.phone_number || "",
        phone_code: this.memberInfo?.phone_code || "",
      }
      await kioskService.sendOtpToWhatsApp(dataForm, this.merchantCode).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = this.$t("kiosk.otp.resendSuccess");
            this.setTimeOutNotification();
            this.activeResendOtp = false;
          } else {
            // Shown on the modal's own error line (like a wrong code), not a
            // corner snackbar behind the popup.
            this.errorMessage =
              response.data.result.message || this.$t("kiosk.otp.resendFailed");
            this.isCodeError = false;
          }
        },
        () => {
          this.errorMessage = this.$t("kiosk.otp.resendOffline");
          this.isCodeError = false;
        }
      );
    },

    formatTime(seconds) {
      const m = Math.floor(seconds / 60);
      const s = seconds % 10;
      return `${m}:${s < 10 ? "0" : s}`;
    },

    startCountdown() {
      if (this.intervalCountdown) return;

      this.intervalCountdown = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          clearInterval(this.intervalCountdown);
          this.intervalCountdown = null;
          this.activeResendOtp = true;

          setTimeout(() => {
            this.showCountdown = false;
          }, 500);
        }
      }, 1000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

  },
};
</script>

<style scoped>
/* KSK029 — P12 eWallet OTP (theme 2). Sized like the kiosk Sign in modal:
   680px, 40px padding, 32px title, 88px keys. */
.modal {
  overflow-y: hidden;
}
.modal :deep(.ksk-modal) {
  padding: 40px;
}

.ksk-otp {
  display: flex;
  flex-direction: column;
}

.ksk-otp__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ksk-space-2);
}
.ksk-otp__heading {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--ksk-space-1) var(--ksk-space-3);
  min-width: 0;
}
.ksk-otp__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-otp__amount {
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 800;
  color: var(--ksk-primary);
  font-variant-numeric: tabular-nums;
}
.ksk-otp__close {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: -8px -8px -8px 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
}
.ksk-otp__close .material-icons-round {
  font-size: 30px;
}

.ksk-otp__hint {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: var(--ksk-space-2);
  padding: 12px var(--ksk-space-2);
  border-radius: var(--ksk-radius-button);
  background: var(--ksk-surface-muted);
  font-size: 18px;
  line-height: 24px;
  color: var(--ksk-text-secondary);
}
.ksk-otp__hint strong {
  color: var(--ksk-text);
  font-weight: 600;
  white-space: nowrap;
}
.ksk-otp__wa {
  flex: none;
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.ksk-otp__display {
  position: relative;
  display: flex;
  justify-content: center;
  gap: var(--ksk-space-2);
  margin-top: var(--ksk-space-3);
}
.ksk-otp__hidden {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  caret-color: transparent;
}
.ksk-otp__box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 112px;
  border: 2px solid transparent;
  border-radius: 20px;
  background: var(--ksk-surface-muted);
  font-size: 52px;
  line-height: 1;
  font-weight: 700;
  color: var(--ksk-text);
  font-variant-numeric: tabular-nums;
  pointer-events: none;
}
.ksk-otp__box--active {
  border-color: var(--ksk-primary);
  background: var(--ksk-surface);
}
.ksk-otp__box--error {
  border-color: var(--ksk-error);
}

.ksk-otp__error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ksk-space-1);
  min-height: 28px;
  margin: 12px 0;
  font-size: 18px;
  line-height: 28px;
  color: var(--ksk-error);
  text-align: center;
}
.ksk-otp__error .material-icons-round {
  font-size: 24px;
}

.ksk-otp__body {
  display: flex;
  gap: var(--ksk-space-2);
  align-items: stretch;
}
/* Same keys as the Sign in modal: 88px rows, muted fill. */
.ksk-otp__keypad {
  flex: 1 1 auto;
  min-width: 0;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 88px;
}
.ksk-otp__keypad :deep(.ksk-keypad__key) {
  background: var(--ksk-surface-muted);
  border-color: transparent;
  font-size: 40px;
  line-height: 48px;
  font-weight: 600;
}
.ksk-otp__side {
  flex: 0 0 196px;
  display: flex;
  flex-direction: column;
  gap: var(--ksk-space-2);
}
.ksk-otp__qr-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: var(--ksk-space-2) 12px;
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface-muted);
  text-align: center;
}
.ksk-otp__qr-title {
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
  color: var(--ksk-text);
}
.ksk-otp__qr-caption {
  font-size: 15px;
  line-height: 20px;
  color: var(--ksk-text-secondary);
}
.ksk-otp__qr {
  width: 148px;
  height: 148px;
  margin-top: var(--ksk-space-1);
  padding: 8px;
  border-radius: var(--ksk-radius-button);
  background: #ffffff;
  object-fit: contain;
}
.ksk-otp__qr--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ksk-text-secondary);
}
.ksk-otp__qr--empty .material-icons-round {
  font-size: 72px;
}
.ksk-otp__resend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 64px;
  border: 2px solid var(--ksk-primary);
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  color: var(--ksk-primary);
  font-family: var(--ksk-font);
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}
.ksk-otp__resend:disabled {
  border-color: transparent;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text-secondary);
  cursor: not-allowed;
}
.ksk-otp__resend .material-icons-round {
  font-size: 24px;
}
</style>
